export const AZURE_SEARCH_DEFAULT_AXIOS_CONFIG = {
  method: 'post',
  headers: { 'api-key': process.env.VUE_APP_AZURE_SEARCH_KEY },
  params: { 'api-version': process.env.VUE_APP_AZURE_SEARCH_API_VERSION },
}
